import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addBanner, updateBanner } from "../../app/Slices";

import { useAlert, useConfirmationDialog } from "@/";
import {
  Button,
  AddressInputField,
  InputField,
  FileUploadInput,
} from "@/components";
const BannerForm = ({ setAlertOpen = false, data = {}, isEdit = false }) => {
  const { alert, AlertDialog } = useAlert();
  const { confirm, ConfirmationModal } = useConfirmationDialog();
  console.log("formData:::", data, isEdit);
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    id: data?.id || null,
    description: data?.subtitle || "",
    title: data?.title || "",
    file: data?.imageUrl || null, // Set file as null initially
  });
  const handleChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const [error, setError] = useState("");
  const handleFileChange = (key, file) => {
    console.log("Selected File:", file); // Debugging

    if (file && file instanceof File) {
      setFilters((prevFilters) => ({
        ...prevFilters,
        [key]: file,
      }));
      setError("");
    } else {
      console.error("Invalid file selected");
      setError("Please select a valid file.");
    }
  };
  const handleAddBanner = async () => {
    console.log("Filters before submitting:", filters); // Debugging check

    if (!filters.title.trim() || !filters.description.trim() || !filters.file) {
      await alert("Please fill all fields before submitting.");
      return;
    }
    await confirm("Are you sure you want to add this banner?");
    try {
      const formData = new FormData();
      formData.append("title", filters.title);
      formData.append("subtitle", filters.description);
      formData.append("image", filters.file); // Ensure file is attached

      console.log("FormData contents:", formData.get("image")); // Debugging

      await dispatch(
        addBanner({
          title: filters.title,
          subtitle: filters.description,
          image: filters.file, // Ensure this is correctly passed
        })
      ).unwrap();
      await alert("Banner added successfully!");
      setAlertOpen(false);
      setFilters({
        id: "",
        description: "",
        title: "",
        file: null, // Reset file properly
      });
    } catch (error) {
      await alert(error || "Failed to add banner.");
    }
  };
  const handleEditBanner = async () => {
    console.log("Filters before updating:", filters); // Debugging check

    if (!filters.id || !filters.title.trim() || !filters.description.trim()) {
      alert("Please fill all fields before updating.");
      return;
    }
    await confirm("Are you sure you want to update the banner?");
    try {
      const formData = new FormData();
      formData.append("title", filters.title);
      formData.append("subtitle", filters.description);
      if (filters.file) {
        formData.append("image", filters.file); // Only append if a new file is selected
      }

      console.log("FormData contents:", formData.get("image")); // Debugging

      await dispatch(
        updateBanner({
          id: filters.id,
          title: filters.title,
          subtitle: filters.description,
          image: filters.file || null, // Ensure this is correctly passed
        })
      ).unwrap();
      await alert("Banner updated successfully!");
      setAlertOpen(false);
      setFilters({
        id: "",
        description: "",
        title: "",
        file: null, // Reset file properly
      });
    } catch (error) {
      await alert(error || "Failed to update banner.");
    }
  };

  return (
    <div className="flex flex-col gap-2 ">
      <InputField
        label="Title"
        placeholder="Enter the title of banner"
        value={filters.title}
        onChange={(value) => handleChange("title", value)}
      />
      <AddressInputField
        label="Description"
        placeholder="Enter the description of banner"
        value={filters.description}
        onChange={(value) => handleChange("description", value)}
      />
      <FileUploadInput
        id="banner-image"
        label="Banner image (if any)"
        disabled={false}
        error={error}
        className="max-w-full p-0"
        onChange={(file) => handleFileChange("file", file)} // Pass selected file
      />
      <div className="w-full">
        <Button
          className="h-12 w-full mt-4"
          size="md"
          onClick={isEdit ? handleEditBanner : handleAddBanner}
        >
          {isEdit ? "Edit Banner" : "Add Banner"}
        </Button>
      </div>
      <AlertDialog />
      <ConfirmationModal />
    </div>
  );
};

export default BannerForm;
